/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // MENU TOGGLE

        function disableScroll() {
          $('html').toggleClass('u-no-scroll');
        }

        $(function(){

          var menuToggle = ('.menu-toggle');
          var navDropdown = ('.nav-primary');

          $(menuToggle).click(function() {
            disableScroll();
            $(this).toggleClass('close-icon');
            $(navDropdown).toggleClass('toggled');
            // close any open submenus
            $('.menu-item-has-children.open').toggleClass('open')
          });

        });

        $(function () {
          var items = ".menu-item-has-children > a";

          $(items).on("click", function (e) {
            if (window.innerWidth < 1024) {
              var $parent = $(this).parent();

              if ($parent) {
                e.preventDefault(); // close submenu
              }
              $parent.toggleClass("open");
            }
          });
        });

        //add background to header on scroll

        $(function() {
          $(window).scroll(function() {
            var header = ('.banner');
            var scrollTop = $(window).scrollTop();
            var windowHeight = $(window).height();
            // CHANGE
            if ( scrollTop > 1 ){
              $(header).addClass('sticky');
              // console.log(scrollTop);
            } else {
              $(header).removeClass('sticky');
            }
          });
        });

        //modal

        (function() {

              var $close_modal = $('.close-modal');
              var $open_modal = $('.open-modal');
              var $modal_content = $('#modal-content');

              var clicked_el = '';
              var $body = $('html');
              var $getNext = $('.right-arrow');
              var $getPrev = $('.left-arrow');
              var imgSrcs = [];

              for ( i = 0; i < $open_modal.length; i++ ) {
                imgSrcs.push($open_modal[i]);

                $(imgSrcs[i]).on('click', function() {

                    var allMods = $(".anim");
                    var allLazy = $(".lazy");

                    allMods.each(function(i, el) {
                      var el = $(el);
                      var imgSrc = el.find('img');

                        imgSrc.attr({
                          src: imgSrc.attr('data-src')
                        }).removeAttr('data-src');

                    });

                    allLazy.each(function(i, el) {
                      var el = $(el);
                        el.attr({
                          src: el.attr('data-src')
                        }).removeAttr('data-src');
                    });

                  clicked_el = this;
                  var image_href = this.src;
                  var image_data = $(this).attr('data-src');
                  var imgPosition = imgSrcs.indexOf(this);
                  // console.log(imgPosition);


                  $modal_content.html('<img class="slideshow" src="' + image_href + '" />');
                  $body.addClass('u-no-scroll has-modal');
                  $close_modal.focus();

                  var myArray = imgSrcs;
                    // console.log(myArray);
                  var totalImages = myArray.length;
                  var myIndex = imgPosition;
                    // console.log(myIndex);
                  var print = $('#modal-content');
                    // console.log(print);

                    // print.innerHTML = myArray[0];
                    // print.html('<img class="slideshow" src="' + myArray[myIndex].src + '" />');

                    $getNext.on('click', function() {
                      myIndex = (myIndex+1) % totalImages;
                      // console.log(myIndex);
                      print.html('<img class="slideshow" src="' + myArray[myIndex].src + '" />');
                    });

                    $getPrev.on('click', function() {
                      myIndex = (myIndex-1) % totalImages;
                      if (myIndex == -1 ) { myIndex = totalImages-1;}
                      // console.log(myIndex);
                      // console.log(totalImages);
                      print.html('<img class="slideshow" src="' + myArray[myIndex].src + '" />');
                    });

                });
              }

              $close_modal.on('click', function() {
                $body.removeClass('u-no-scroll has-modal');
                $(clicked_el).focus();
              });

              $('.modal').on('click', function(e) {
                if(!$(e.target).is('img')) {
                  $body.removeClass('u-no-scroll has-modal');
                  $(clicked_el).focus();
                }

              });

          })();


        /*============================================================================
          #Animations
        ==============================================================================*/

        (function($) {

          /**
           * Copyright 2012, Digital Fusion
           * Licensed under the MIT license.
           * http://teamdf.com/jquery-plugins/license/
           *
           * @author Sam Sehnert
           * @desc A small plugin that checks whether elements are within
           *     the user visible viewport of a web browser.
           *     only accounts for vertical position, not horizontal.
           */

          $.fn.visible = function(partial) {

              var $t            = $(this),
                  $w            = $(window),
                  viewTop       = $w.scrollTop(),
                  viewBottom    = viewTop + $w.height(),
                  _top          = $t.offset().top,
                  _bottom       = _top + $t.height(),
                  compareTop    = partial === true ? _bottom : _top,
                  compareBottom = partial === true ? _top : _bottom;

            return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

          };

          })(jQuery);

          var win = $(window);

          var allMods = $(".anim");
          // var allLazy = $(".lazy");

          allMods.each(function(i, el) {
            var el = $(el);
            var imgSrc = el.find('img');
            if (el.visible(true)) {
              // console.log('top');
              // imgSrc.attr({
              //   src: imgSrc.attr('data-src')
              // }).removeAttr('data-src');
              el.addClass("already-visible");
            }
            // var modalContent = $('.modal-content');
          });

          // allMods.each(function() {
          //   if ($('.modal-content').visible(true)) {
          //     imgSrc.attr({
          //       src: imgSrc.attr('data-src')
          //     }).removeAttr('data-src');
          //   }
          // });

          // allLazy.each(function(i, el) {
          //   var el = $(el);
          //   if (el.visible(true)) {
          //     el.attr({
          //       src: el.attr('data-src')
          //     }).removeAttr('data-src');
          //     el.addClass("go");
          //   }
          // });

          win.scroll(function(event) {

            allMods.each(function(i, el) {
              var el = $(el);
              var imgSrc = el.find('img');
              if (el.visible(true)) {
                // console.log('top');
                // imgSrc.attr({
                //   src: imgSrc.attr('data-src')
                // }).removeAttr('data-src');
                el.addClass("go");
              }
            });

            // allLazy.each(function(i, el) {
            //   var el = $(el);
            //   if (el.visible(true)) {
            //     console.log('top');
            //     el.attr({
            //       src: el.attr('data-src')
            //     }).removeAttr('data-src');
            //     ('.anim').addClass("go");
            //   }
            // });

          });

        //slide up/fadein items with anim class
        // $(function() {

        //   $(window).scroll(function() {
        //     var scrollTop = $(window).scrollTop();
        //     var viewportHeight = $(window).height();
        //     $('.anim:not(.go)').each(function () {
        //         var top = $(this).offset().top;
        //         if(scrollTop + viewportHeight >= top ){
        //             $(this).addClass('go');
        //         }
        //     });
        //   });
        // });

        //bw to color on scroll
        $(function() {
          $(window).scroll(function() {
            var scrollTop = $(window).scrollTop() - 400;
            var viewportHeight = $(window).height();
            $('.gray:not(.color)').each(function () {
                var top = $(this).offset().top;
                if(scrollTop + viewportHeight >= top ){
                    $(this).addClass('color');
                }
            });
          });
        });

        //blue image fade to color
        $(function() {
          $(window).scroll(function() {
            $('.color-image').addClass('visible');
            $('.blue-image').addClass('faded');
          });
        });

        // Video Module
        $(function() {
          $('.module-video .cover').on('click', function() {
            $(this).fadeOut(200);
            $(this).prev().attr('src', $(this).prev().attr('src') + '&autoplay=1'); 
          });
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        
        // HERO SLIDER
        var hero = document.getElementById("hero");
        if (hero) {
          var images = JSON.parse(hero.dataset.images || "[]").filter(Boolean);
          if (!images.length) return;

          var bg = hero.querySelector(".hero-bg");
          var bgNext = hero.querySelector(".hero-bg-next");

          var current = Math.floor(Math.random() * images.length);
          var interval;

          function applyImage(el, image) {
            el.style.backgroundImage = "url('" + image.url + "')";
            el.style.backgroundPosition = "center center";
          }

          function showImage(index) {
            applyImage(bgNext, images[index]);
            bgNext.style.opacity = 1;

            setTimeout(function () {
              applyImage(bg, images[index]);
              bgNext.style.opacity = 0;
            }, 1500);
          }

          function next() {
            current = (current + 1) % images.length;
            showImage(current);
          }

          function prev() {
            current = (current - 1 + images.length) % images.length;
            showImage(current);
          }

          applyImage(bg, images[current]);

          interval = setInterval(next, 5000);

          var nextBtn = hero.querySelector(".hero-next");
          var prevBtn = hero.querySelector(".hero-prev");

          function resetInterval() {
            clearInterval(interval);
            interval = setInterval(next, 5000);
          }

          if (nextBtn) {
            nextBtn.addEventListener("click", function () {
              next();
              resetInterval();
            });
          }

          if (prevBtn) {
            prevBtn.addEventListener("click", function () {
              prev();
              resetInterval();
            });
          }
        }

        $(function() {

          var project0 = ('.feature-link-0');
          var project1 = ('.feature-link-1');
          var project2 = ('.feature-link-2');

          var projectImg0 = ('.feature-image-0');
          var projectImg1 = ('.feature-image-1');
          var projectImg2 = ('.feature-image-2');

          // var featuredProjects = [project0, project1, project2];
          // var featuredImgs = [projectImg0, projectImg1, projectImg2];
          // console.log(featuredImgs);
          // console.log(featuredProjects);

          $(projectImg0).addClass('ftr-visible');

          $(project0).mouseover(function() {
            $(projectImg0).addClass('ftr-visible');
            $(projectImg1).removeClass('ftr-visible');
            $(projectImg2).removeClass('ftr-visible');
            // console.log('visible0');
          });

          $(project1).mouseover(function() {
            $(projectImg1).addClass('ftr-visible');
            $(projectImg0).removeClass('ftr-visible');
            $(projectImg2).removeClass('ftr-visible');
            // console.log('visible0');
          });

          $(project2).mouseover(function() {
            $(projectImg2).addClass('ftr-visible');
            $(projectImg0).removeClass('ftr-visible');
            $(projectImg1).removeClass('ftr-visible');
            // console.log('visible0');
          });

        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    // Contact page.
    'contact': {
      init: function() {
        // JavaScript to be fired on the contact page


        $(function() {

        /*
        *  new_map
        *
        *  This function will render a Google Map onto the selected jQuery element
        *
        *  @type  function
        *  @date  8/11/2013
        *  @since 4.3.0
        *
        *  @param $el (jQuery element)
        *  @return  n/a
        */

        function new_map( $el ) {

          // var
          var $markers = $el.find('.marker');


          // vars
          var args = {
            zoom    : 16,
            minZoom : 9,
            maxZoom : 18,
            scaleControl: false,
            streetViewControl: false,
            overviewMapControl: false,
            draggable: true,
            disableDoubleClickZoom: false,
            center    : new google.maps.LatLng(0, 0),
            mapTypeId : google.maps.MapTypeId.ROADMAP,
            mapTypeControlOptions: {
            mapTypeIds: ['roadmap',
                    'map_style'],
            position: google.maps.ControlPosition.TOP_RIGHT
            },
            panControl: true,
            panControlOptions: {
              position: google.maps.ControlPosition.TOP_RIGHT
            },
            zoomControl: true,
            zoomControlOptions: {
              style: google.maps.ZoomControlStyle.LARGE,
              position: google.maps.ControlPosition.TOP_RIGHT
            },
            scrollwheel: false,
            mapTypeControl: false,
            styles : [
                      {
                        "elementType": "geometry",
                        "stylers": [
                          {
                            "color": "#f5f5f5"
                          }
                        ]
                      },
                      {
                        "elementType": "labels.icon",
                        "stylers": [
                          {
                            "visibility": "off"
                          }
                        ]
                      },
                      {
                        "elementType": "labels.text.fill",
                        "stylers": [
                          {
                            "color": "#616161"
                          }
                        ]
                      },
                      {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                          {
                            "color": "#f5f5f5"
                          }
                        ]
                      },
                      {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [
                          {
                            "color": "#bdbdbd"
                          }
                        ]
                      },
                      {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                          {
                            "color": "#eeeeee"
                          }
                        ]
                      },
                      {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [
                          {
                            "color": "#757575"
                          }
                        ]
                      },
                      {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                          {
                            "color": "#e5e5e5"
                          }
                        ]
                      },
                        {
                          "featureType": "poi.business",
                          "stylers": [
                            {
                              "visibility": "off"
                            }
                          ]
                        },
                        {
                          "featureType": "poi.business",
                          "elementType": "labels.icon",
                          "stylers": [
                            {
                              "saturation": -100
                            }
                          ]
                        },
                      {
                        "featureType": "poi.park",
                        "elementType": "labels.text.fill",
                        "stylers": [
                          {
                            "color": "#9e9e9e"
                          }
                        ]
                      },
                      {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                          {
                            "color": "#ffffff"
                          }
                        ]
                      },
                      {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [
                          {
                            "color": "#757575"
                          }
                        ]
                      },
                      {
                        "featureType": "road.highway",
                        "elementType": "geometry",
                        "stylers": [
                          {
                            "color": "#dadada"
                          }
                        ]
                      },
                      {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [
                          {
                            "color": "#616161"
                          }
                        ]
                      },
                      {
                        "featureType": "road.local",
                        "elementType": "labels.text.fill",
                        "stylers": [
                          {
                            "color": "#9e9e9e"
                          }
                        ]
                      },
                      {
                        "featureType": "transit.line",
                        "elementType": "geometry",
                        "stylers": [
                          {
                            "color": "#e5e5e5"
                          }
                        ]
                      },
                      {
                        "featureType": "transit.station",
                        "elementType": "geometry",
                        "stylers": [
                          {
                            "color": "#eeeeee"
                          }
                        ]
                      },
                      {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                          {
                            "color": "#c9c9c9"
                          }
                        ]
                      },
                      {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                          {
                            "color": "#9e9e9e"
                          }
                        ]
                      }
                    ]
          };



        // create map
        var map = new google.maps.Map( $el[0], args);

        // add a markers reference
        map.markers = [];

        // add markers
        $markers.each(function(){
            add_marker( $(this), map );
        });

        // center map
        center_map( map );

        // return
        return map;
      }

        /*
        *  add_marker
        *
        *  This function will add a marker to the selected Google Map
        *
        *  @type  function
        *  @date  8/11/2013
        *  @since 4.3.0
        *
        *  @param $marker (jQuery element)
        *  @param map (Google Map object)
        *  @return  n/a
        */

        function add_marker( $marker, map ) {

          // var
          var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

          // create marker
          var marker = new google.maps.Marker({
            position  : latlng,
            map     : map,
            icon: '/app/themes/falkenreynolds/assets/images/map-marker.png',
            scale: 1,
            // icon : {
            //   // path: 'M7.87565707,0.500012245 C10.7981254,0.500012245 13.3234302,2.30025272 14.3752266,4.84864508 C14.7022508,5.66693621 14.889581,6.55536657 14.9129607,7.51393618 C14.9129607,9.0336197 14.4219861,10.4364045 13.6036949,11.5820121 L13.2763785,12.0028475 L7.87565707,19.0167714 L2.59183437,12.143126 C2.38141665,11.9093285 2.19437868,11.6521513 2.03072045,11.3949741 C1.28256857,10.2727463 0.861733132,8.94010071 0.861733132,7.51393618 C0.861733132,6.55536657 1.02539136,5.66693621 1.37608755,4.84864508 C2.42817614,2.30025272 4.95318876,0.500012245 7.87565707,0.500012245 Z M8,9 C9.1045695,9 10,8.1045695 10,7 C10,5.8954305 9.1045695,5 8,5 C6.8954305,5 6,5.8954305 6,7 C6,8.1045695 6.8954305,9 8,9 Z',
            //   // fillColor: '#2c2d2e',
            //   // fillOpacity: 1,
            //   // strokeColor: '#2c2d2e',
            // },
          });

          // add to array
          map.markers.push( marker );

          // if marker contains HTML, add it to an infoWindow
          if( $marker.html() )
          {
            // create info window
            var infowindow = new google.maps.InfoWindow({
              content   : $marker.html()
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function() {

              infowindow.open( map, marker );

            });
          }

        }

        /*
        *  center_map
        *
        *  This function will center the map, showing all markers attached to this map
        *
        *  @type  function
        *  @date  8/11/2013
        *  @since 4.3.0
        *
        *  @param map (Google Map object)
        *  @return  n/a
        */

        function center_map( map ) {

          // vars
          var bounds = new google.maps.LatLngBounds();

          // loop through all markers and create bounds
          $.each( map.markers, function( i, marker ){

            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

            bounds.extend( latlng );

          });

          // only 1 marker?
          if( map.markers.length == 1 )
          {
            // set center of map
              map.setCenter( bounds.getCenter() );
              map.setZoom( 16 );
          }
          else
          {
            // fit to bounds
            map.fitBounds( bounds );
          }

        }


        /*
        *  document ready
        *
        *  This function will render each map when the document is ready (page has loaded)
        *
        *  @type  function
        *  @date  8/11/2013
        *  @since 5.0.0
        *
        *  @param n/a
        *  @return  n/a
        */
        // global var
        var map = null;

        $(document).ready(function(){

          $('.acf-map').each(function(){

            // create map
            map = new_map( $(this) );

          });

        });

        });
      }
    },
    'category': {
      init: function() {
        // JavaScript to be fired on category pages

        // add active class to blog links

        $(function() {
          $('.post-categories li a[href^="http://falkenreynolds.burnkit.com/press/' + location.pathname.split("/")[2] + '"]').addClass('active');
          // console.log(location.pathname.split("/")[2]);
          // console.log(location.pathname);
        });

      }
    },
    'projects': {
      init: function() {
        // JavaScript to be fired on projects pages

        // add active class to tax links

        // $(function() {
        //   $('.post-categories li a[href^="/projects/' + location.pathname.split("/")[2] + '"]').addClass('active');
        //   // console.log(location.pathname.split("/")[2]);
        //   // console.log(location.pathname);
        // });

      }
    },
    // 'index': {
    //   init: function() {
    //     var count = 2;
    //     $(window).scroll(function(){
    //       if  ($(window).scrollTop() == $(document).height() - $(window).height()){
    //         loadArticle(count);
    //         count++;
    //       }
    //     });

    //     function loadArticle(pageNumber){
    //       $.ajax({
    //         url: "<?php bloginfo('wpurl') ?>/wp-admin/admin-ajax.php",
    //         type:'POST',
    //         data: "action=infinite_scroll&page_no="+ pageNumber + '&loop_file=loop',
    //         success: function(html){
    //             $("#content").append(html);   // This will be the div where our content will be loaded
    //             console.log('posts loaded');
    //         }
    //       });
    //     return false;
    //     }
    //   }
    // },
    'archive': {
      init: function() {
        // JavaScript to be fired on type taxonomy archive pages

        // add active class to tax links

        $(function() {
          $('.post-categories li a[href^="/projects/' + location.pathname.split("/")[2] + '"]').addClass('active');
          // console.log(location.pathname.split("/")[2]);
          // console.log(location.pathname);
        });

      }
    }

  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
